import { render, staticRenderFns } from "./ProCard4.vue?vue&type=template&id=65c92f4a&scoped=true"
import script from "./ProCard4.vue?vue&type=script&lang=js"
export * from "./ProCard4.vue?vue&type=script&lang=js"
import style0 from "./ProCard4.vue?vue&type=style&index=0&id=65c92f4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c92f4a",
  null
  
)

export default component.exports